module.exports = __webpack_public_path__ + "img/ico-bonos.9037f8a0.svg";